import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { LessonAttachment } from '../services/backendService/backendService';

const useCreateAttachment = () => {
  const { mutate: createAttachment, isLoading: isCreatingAttachment } = useMutation(
    ({
      data: { content, title },
    }: {
      data: { title: string; content: string };
      onSuccessFunction?: (data: LessonAttachment) => void | undefined;
    }) => {
      return BackendService.instance.presentations.createAttachment({
        content,
        title,
      });
    },
    {
      onSuccess: (data, { onSuccessFunction }) => {
        if (onSuccessFunction && data) {
          onSuccessFunction(data);
        }
      },
    },
  );

  return {
    createAttachment,
    isCreatingAttachment,
  };
};
export default useCreateAttachment;
